import React from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
    Divider,
    Stack,
    Paper,
    Grid,
    Tooltip,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineOppositeContent
} from '@mui/lab';
import { diplomes, job, pdg, teaching } from "./meta/cv";
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import EngineeringIcon from '@mui/icons-material/Engineering';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CodeIcon from '@mui/icons-material/Code';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LanguageIcon from '@mui/icons-material/Language';
import TerminalIcon from '@mui/icons-material/Terminal';
import StorageIcon from '@mui/icons-material/Storage';
import BrushIcon from '@mui/icons-material/Brush';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import DevicesIcon from '@mui/icons-material/Devices';
import CloudIcon from '@mui/icons-material/Cloud';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import {
    SiC, SiCplusplus, SiSharp,
    SiHtml5, SiCss, SiSass, SiPhp, SiJavascript, SiTypescript,
    SiGnubash, SiPerl, SiPython,
    SiMysql, SiMongodb, SiApachecassandra,
    SiOpengl, SiVulkan, SiUnity,
    SiApachestorm, SiYarn,
    SiDocker, SiKubernetes, SiJenkins, SiTerraform, SiAnsible,
    SiArduino, SiRaspberrypi, SiMqtt,
    SiGooglecloud, SiOpenstack,
    SiThreedotjs, SiWebgl
} from 'react-icons/si';

const skillCategories = [
    {
        label: 'Programmation',
        color: '#1565c0',
        muiIcon: <DataObjectIcon fontSize="small" />,
        skills: [
            { name: 'C',    icon: SiC },
            { name: 'C++',  icon: SiCplusplus },
            { name: 'C#',   icon: SiSharp },
            { name: 'Java', icon: null },
        ]
    },
    {
        label: 'Web',
        color: '#e65100',
        muiIcon: <LanguageIcon fontSize="small" />,
        skills: [
            { name: 'HTML',       icon: SiHtml5 },
            { name: 'CSS',        icon: SiCss },
            { name: 'SASS',       icon: SiSass },
            { name: 'PHP',        icon: SiPhp },
            { name: 'JavaScript', icon: SiJavascript },
            { name: 'TypeScript', icon: SiTypescript },
        ]
    },
    {
        label: 'Scripting',
        color: '#2e7d32',
        muiIcon: <TerminalIcon fontSize="small" />,
        skills: [
            { name: 'Bash',   icon: SiGnubash },
            { name: 'Perl',   icon: SiPerl },
            { name: 'Python', icon: SiPython },
        ]
    },
    {
        label: 'Bases de données',
        color: '#6a1b9a',
        muiIcon: <StorageIcon fontSize="small" />,
        skills: [
            { name: 'MySQL',      icon: SiMysql },
            { name: 'Oracle',     icon: null },
            { name: 'SQL Server', icon: null },
            { name: 'MongoDB',    icon: SiMongodb },
            { name: 'Cassandra',  icon: SiApachecassandra },
        ]
    },
    {
        label: 'Infographie',
        color: '#00695c',
        muiIcon: <BrushIcon fontSize="small" />,
        skills: [
            { name: 'OpenGL',         icon: SiOpengl },
            { name: 'DirectX',        icon: null },
            { name: 'Vulkan',         icon: SiVulkan },
            { name: 'OpenSceneGraph', icon: null },
            { name: 'Ogre 3D',        icon: null },
            { name: 'Unity 3D',       icon: SiUnity },
        ]
    },
    {
        label: 'Parallélisme',
        color: '#4527a0',
        muiIcon: <AccountTreeIcon fontSize="small" />,
        skills: [
            { name: 'OpenMP',    icon: null },
            { name: 'TBB',       icon: null },
            { name: 'Cilk',      icon: null },
            { name: 'OpenCL',    icon: null },
            { name: 'MPI',       icon: null },
            { name: 'MapReduce', icon: null },
            { name: 'Storm',     icon: SiApachestorm },
            { name: 'Yarn',      icon: SiYarn },
        ]
    },
    {
        label: 'DevOps',
        color: '#b71c1c',
        muiIcon: <BuildCircleIcon fontSize="small" />,
        skills: [
            { name: 'Docker',     icon: SiDocker },
            { name: 'Kubernetes', icon: SiKubernetes },
            { name: 'Jenkins',    icon: SiJenkins },
            { name: 'Terraform',  icon: SiTerraform },
            { name: 'Ansible',    icon: SiAnsible },
        ]
    },
    {
        label: 'IoT',
        color: '#0277bd',
        muiIcon: <DevicesIcon fontSize="small" />,
        skills: [
            { name: 'Arduino',      icon: SiArduino },
            { name: 'Raspberry Pi', icon: SiRaspberrypi },
            { name: 'MQTT',         icon: SiMqtt },
            { name: 'LoRa',         icon: null },
            { name: 'LoRaWAN',      icon: null },
        ]
    },
    {
        label: 'Cloud',
        color: '#f57f17',
        muiIcon: <CloudIcon fontSize="small" />,
        skills: [
            { name: 'GCP',       icon: SiGooglecloud },
            { name: 'AWS',       icon: null },
            { name: 'OpenStack', icon: SiOpenstack },
        ]
    },
    {
        label: 'Visualisation 3D',
        color: '#37474f',
        muiIcon: <ViewInArIcon fontSize="small" />,
        skills: [
            { name: 'Three.js', icon: SiThreedotjs },
            { name: 'Unity',    icon: SiUnity },
            { name: 'WebGL',    icon: SiWebgl },
        ]
    },
];

const SkillPill = ({ name, IconComp, color }) => (
    <Tooltip title={name} arrow placement="top">
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.6,
            px: 1.2,
            py: 1,
            borderRadius: 2.5,
            border: '1px solid',
            borderColor: `${color}30`,
            bgcolor: 'white',
            color: color,
            minWidth: 62,
            cursor: 'default',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            '&:hover': {
                bgcolor: `${color}10`,
                borderColor: `${color}80`,
                transform: 'translateY(-4px)',
                boxShadow: `0 8px 20px ${color}28`,
            }
        }}>
            {IconComp ? (
                <IconComp size={22} color={color} />
            ) : (
                <Box sx={{
                    width: 22, height: 22,
                    borderRadius: '6px',
                    background: `linear-gradient(135deg, ${color}30, ${color}18)`,
                    border: `1px solid ${color}40`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.58rem',
                    fontWeight: 900,
                    color: color,
                    letterSpacing: '-0.5px',
                }}>
                    {name.slice(0, 3).toUpperCase()}
                </Box>
            )}
            <Typography sx={{
                fontSize: '0.65rem',
                fontWeight: 700,
                textAlign: 'center',
                lineHeight: 1.2,
                color: color,
                maxWidth: 60,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
                {name}
            </Typography>
        </Box>
    </Tooltip>
);

export default function Benoit() {

    const renderTimeline = (data, icon, color) => (
        <Timeline position="right" sx={{ p: 0 }}>
            {data.sort((a, b) => b.startDate - a.startDate).map((item, index) => (
                <TimelineItem key={index}>
                    <TimelineOppositeContent sx={{ m: 'auto 0', flex: 0.2 }} variant="caption" color="text.secondary">
                        {item.startDate} - {item.endDate || 'Présent'}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ bgcolor: color }}>
                            {icon}
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                        <Typography variant="subtitle1" component="span" sx={{ fontWeight: 700 }}>
                            {item.title}
                        </Typography>
                        <Typography variant="body2" color="primary">
                            {item.school || item.company}
                            <Typography component="span" variant="caption" color="text.secondary">
                                &nbsp;({item.city}, {item.country})
                            </Typography>
                        </Typography>
                        <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 0.5 }}>
                            {item.speciality}
                        </Typography>
                    </TimelineContent>
                </TimelineItem>
            ))}
        </Timeline>
    );

    return (
        <Box sx={{ p: { xs: 2, md: 5 }, bgcolor: '#f4f7f9', minHeight: '100vh' }}>

            <Typography variant="h3" sx={{ fontWeight: 800, color: '#1a237e', mb: 4, textAlign: 'center' }}>
                Cursus & Expériences
            </Typography>

            <Stack spacing={4}>
                {/* Diplômes */}
                <Paper sx={{ p: 3, borderRadius: 4 }}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2, px: 2 }}>
                        <SchoolIcon color="primary" />
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>Formation Académique</Typography>
                    </Stack>
                    <Divider sx={{ mb: 2 }} />
                    {renderTimeline(diplomes, <SchoolIcon fontSize="small" />, '#1976d2')}
                </Paper>

                {/* Enseignement */}
                <Paper sx={{ p: 3, borderRadius: 4 }}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2, px: 2 }}>
                        <WorkIcon sx={{ color: '#ed6c02' }} />
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>Enseignement & Recherche</Typography>
                    </Stack>
                    <Divider sx={{ mb: 2 }} />
                    {renderTimeline(teaching, <SchoolIcon fontSize="small" />, '#ed6c02')}
                </Paper>

                {/* Expériences Pro (Ingénieur & Entrepreneur) */}
                <Box sx={{ mt: 4 }}>
                    <Grid container spacing={3} alignItems="stretch" sx={{ justifyContent: 'space-between' ,display: 'flex', alignItems: 'center' }}>
                        {/* Utilisation de md={6} pour faire 50/50 sur écran large */}
                        <Grid item xs={12} md={6} sx={{ display: 'flex',width: '45%' }}>
                            <Card sx={{
                                flex: 1, // Force la carte à prendre toute la hauteur de la ligne
                                borderRadius: 4,
                                border: '1px solid #e0e0e0',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }}>
                                <CardContent>
                                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                        <EngineeringIcon color="secondary" />
                                        <Typography variant="h5" sx={{ fontWeight: 700 }}>Ingénierie R&D</Typography>
                                    </Stack>
                                    <Divider sx={{ mb: 2 }} />
                                    <List dense>
                                        {job.map((item, i) => (
                                            <ListItem key={i} sx={{ px: 0, alignItems: 'flex-start' }}>
                                                <ListItemText
                                                    primary={item.title}
                                                    secondary={`${item.school} | ${item.startDate} - ${item.endDate || 'Présent'}`}
                                                    primaryTypographyProps={{ fontWeight: 600, variant: 'body2' }}
                                                    secondaryTypographyProps={{ variant: 'caption' }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ display: 'flex',width: '45%' }}>
                            <Card sx={{
                                flex: 1, // Force la carte à prendre toute la hauteur de la ligne
                                borderRadius: 4,
                                border: '1px solid #e0e0e0',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }}>
                                <CardContent>
                                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                        <RocketLaunchIcon sx={{ color: '#4caf50' }} />
                                        <Typography variant="h5" sx={{ fontWeight: 700 }}>Entrepreneuriat</Typography>
                                    </Stack>
                                    <Divider sx={{ mb: 2 }} />
                                    <List dense>
                                        {pdg.map((item, i) => (
                                            <ListItem key={i} sx={{ px: 0, alignItems: 'flex-start' }}>
                                                <ListItemText
                                                    primary={item.title}
                                                    secondary={`${item.school} | ${item.startDate} - ${item.endDate || 'Présent'}`}
                                                    primaryTypographyProps={{ fontWeight: 600, variant: 'body2' }}
                                                    secondaryTypographyProps={{ variant: 'caption' }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>

            {/* Stack Technique */}
            <Paper elevation={0} sx={{
                p: { xs: 2, md: 4 },
                borderRadius: 4,
                mt: 4,
                border: '1px solid rgba(0,0,0,0.08)',
                background: 'linear-gradient(160deg, #f8fafc 0%, #eef2f7 100%)',
                boxShadow: '0 4px 30px rgba(0,0,0,0.07)',
            }}>
                {/* Header */}
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 3 }}>
                    <Box sx={{
                        bgcolor: '#1a237e',
                        borderRadius: 2,
                        p: 0.9,
                        display: 'flex',
                        boxShadow: '0 2px 8px rgba(26,35,126,0.35)',
                    }}>
                        <CodeIcon sx={{ color: 'white', fontSize: 22 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', lineHeight: 1 }}>
                            Stack Technique
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {skillCategories.length} catégories · {skillCategories.reduce((acc, c) => acc + c.skills.length, 0)} technologies
                        </Typography>
                    </Box>
                </Stack>
                <Divider sx={{ mb: 2, borderColor: 'rgba(0,0,0,0.08)' }} />

                {/* Accordion hiérarchique */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                    {skillCategories.map((cat) => (
                        <Accordion
                            key={cat.label}
                            disableGutters
                            elevation={0}
                            sx={{
                                borderRadius: '10px !important',
                                border: `1px solid ${cat.color}28`,
                                overflow: 'hidden',
                                '&:before': { display: 'none' },
                                '&.Mui-expanded': {
                                    border: `1px solid ${cat.color}55`,
                                    boxShadow: `0 4px 20px ${cat.color}18`,
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: cat.color, fontSize: 20 }} />}
                                sx={{
                                    background: `linear-gradient(110deg, ${cat.color}10 0%, white 60%)`,
                                    borderLeft: `4px solid ${cat.color}`,
                                    minHeight: '50px !important',
                                    '& .MuiAccordionSummary-content': { my: '8px', overflow: 'hidden' },
                                    '&.Mui-expanded': {
                                        borderBottom: `1px solid ${cat.color}20`,
                                    },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, overflow: 'hidden', mr: 1 }}>
                                    {/* Icône catégorie */}
                                    <Box sx={{
                                        color: 'white',
                                        bgcolor: cat.color,
                                        borderRadius: 1.5,
                                        p: 0.4,
                                        display: 'flex',
                                        flexShrink: 0,
                                        boxShadow: `0 2px 6px ${cat.color}55`,
                                    }}>
                                        {cat.muiIcon}
                                    </Box>

                                    {/* Label catégorie */}
                                    <Typography sx={{
                                        fontWeight: 700,
                                        color: cat.color,
                                        fontSize: '0.875rem',
                                        letterSpacing: 0.3,
                                        flexShrink: 0,
                                        minWidth: 120,
                                    }}>
                                        {cat.label}
                                    </Typography>

                                    {/* Compteur */}
                                    <Chip
                                        label={cat.skills.length}
                                        size="small"
                                        sx={{
                                            bgcolor: `${cat.color}18`,
                                            color: cat.color,
                                            fontWeight: 800,
                                            height: 20,
                                            fontSize: '0.68rem',
                                            flexShrink: 0,
                                            '& .MuiChip-label': { px: 1 },
                                        }}
                                    />

                                    {/* Aperçu des techs (caché sur mobile) */}
                                    <Typography variant="caption" sx={{
                                        color: 'text.disabled',
                                        display: { xs: 'none', sm: 'block' },
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontSize: '0.7rem',
                                        fontStyle: 'italic',
                                    }}>
                                        {cat.skills.map(s => s.name).join(' · ')}
                                    </Typography>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ px: 2, pt: 1.5, pb: 2, bgcolor: 'white' }}>
                                {/* Ligne de connexion visuelle */}
                                <Box sx={{
                                    display: 'flex',
                                    gap: 1,
                                    '&::before': {
                                        content: '""',
                                        display: 'block',
                                        width: 3,
                                        borderRadius: 4,
                                        bgcolor: `${cat.color}30`,
                                        flexShrink: 0,
                                        ml: 0.5,
                                    }
                                }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8, flex: 1 }}>
                                        {cat.skills.map((skill) => (
                                            <SkillPill
                                                key={skill.name}
                                                name={skill.name}
                                                IconComp={skill.icon}
                                                color={cat.color}
                                            />
                                        ))}
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Paper>

        </Box>
    );
}